/**
 * Audit-log-specific user formatting utilities.
 * For base getUserDisplayName / UserWithName, use @/services/auth.
 */

import { getUserDisplayName } from '@/services/auth/user-display-name';
import type { UserWithName } from '@/services/auth/user-display-name';

/**
 * Get display name with email in parentheses (if name available)
 * Returns "Full Name (email)" if name available, otherwise just email
 */
export function getUserDisplayNameWithEmail(user: UserWithName): string {
  const name = getUserDisplayName(user);
  return name === user.email ? name : `${name} (${user.email})`;
}

/**
 * Format user name from user object
 * Returns "Full Name (email)" if name available, otherwise just email
 * @deprecated Use getUserDisplayNameWithEmail instead
 */
export function formatUserName(user: UserWithName): string {
  return getUserDisplayNameWithEmail(user);
}
